module.exports = __webpack_public_path__ + "img/elo.8d9b073a.svg";